// orders — see README.md. Keys must exist in BOTH maps (checked by npm run check:locales).
export const en = {
  // --- Toasts & confirmations shared by the order screens -------------------
  'orders.toast.error': 'Error',
  'orders.toast.loadTablesFailed': 'Failed to load tables. Please try again.',
  'orders.toast.loadOrdersFailed': 'Failed to load orders. Please try again.',
  'orders.toast.saveOrderFailed': 'Failed to save order. Please try again.',
  'orders.toast.statusUpdated': 'Status Updated',
  'orders.toast.statusUpdatedDesc': '{order} is now {status}',
  'orders.toast.updateStatusFailed': 'Failed to update order status',
  'orders.toast.updateItemFailed': 'Failed to update item status',
  'orders.toast.orderCancelled': 'Order cancelled',
  'orders.toast.orderCancelledDesc': '{order} marked cancelled',
  'orders.toast.cancelFailed': 'Failed to cancel order',
  'orders.toast.loadHistoryFailed': 'Failed to load order history',
  'orders.toast.pickComplimentary': 'Choose complimentary item',
  'orders.toast.pickComplimentaryDesc': 'Please pick one complimentary item for each type.',
  'orders.confirm.cancelOrder': 'Cancel order {order}? Its number stays reserved as cancelled.',
  'orders.confirm.cancelOrderCta': 'Cancel order',

  // WHERE an order came from. LABELS only — `channel` keeps the server's own
  // values (KIOSK / APP / COUNTER / DELIVERY), which analytics groups on.
  'orders.channel.kiosk': 'Kiosk',
  'orders.channel.kioskNamed': 'Kiosk · {name}',
  'orders.channel.app': 'Guest phone',
  'orders.channel.counter': 'Counter',
  'orders.channel.delivery': 'Delivery',
  'orders.channel.online': 'Online',
  'orders.channel.table': 'Table {number}',

  // Status LABELS only — the underlying values stay the server's own strings.
  'orders.status.pending': 'Pending',
  'orders.status.ordered': 'Ordered',
  'orders.status.confirmed': 'Confirmed',
  'orders.status.preparing': 'Preparing',
  'orders.status.ready': 'Ready',
  'orders.status.served': 'Served',
  'orders.status.delivered': 'Delivered',
  'orders.status.completed': 'Completed',
  'orders.status.cancelled': 'Cancelled',
  'orders.status.held': 'Held',

  // --- POS shell: left rail, step chips and serving-time chips --------------
  'orders.nav.home': 'Home',
  'orders.nav.reservations': 'Reservations',
  'orders.nav.activeOrders': 'Active Orders',
  'orders.nav.allOrders': 'All Orders',
  'orders.step.table': 'Table',
  'orders.step.guests': 'Guests',
  'orders.step.menu': 'Menu',
  'orders.step.pay': 'Pay',
  'orders.window.branchHours': 'Branch hours',
  'orders.window.from': 'From {time}',
  'orders.window.until': 'Until {time}',

  'orders.pos.floorMaps': 'Floor maps',
  'orders.pos.loadingFloorMaps': 'Loading floor maps…',
  'orders.pos.noLocation': 'No location selected.',
  'orders.pos.noFloorPlan': 'No floor plan yet. Design one in Locations → Floor Plan.',
  'orders.pos.noSections': 'No sections on this floor.',
  'orders.pos.takeAnOrder': 'Take an Order',
  'orders.pos.noFloorMap': 'No floor map',
  'orders.pos.legendAvailable': 'Available',
  'orders.pos.legendOccupied': 'Occupied',
  'orders.pos.legendSelected': 'Selected',
  'orders.pos.tablesSeats': '{tables} tables · {seats} seats',
  'orders.pos.zoomOut': 'Zoom out',
  'orders.pos.zoomIn': 'Zoom in',
  'orders.pos.fitToScreen': 'Fit to screen',
  'orders.pos.resetZoom': 'Reset zoom to 100%',
  'orders.pos.emptyPickLocation': 'Select a location to load its floor plan',
  'orders.pos.emptyNoFloorPlan': 'No floor plan yet — design one in Locations → Floor Plan',
  'orders.pos.emptyNoTables': 'No tables in this section',
  'orders.pos.selectedLabel': 'Selected',
  'orders.pos.tapTable': 'Tap an available table on the floor map',
  'orders.pos.seats': '{count} seats',
  'orders.pos.reset': 'Reset',
  'orders.pos.next': 'Next',

  // --- Order builder: party size, then menu, then place ---------------------
  'orders.builder.backToTables': '← Tables',
  'orders.builder.tableSummary': '{table} · {seats} seats',
  'orders.builder.newOrder': 'New order',
  'orders.builder.guests': '{count} guest(s)',
  'orders.builder.total': 'Total',
  'orders.builder.howManyGuests': 'How many guests?',
  'orders.builder.upToSeats': 'Up to {count} seats at this table',
  'orders.builder.guestDetails': 'Guest details',
  'orders.builder.guestNamePlaceholder': 'Guest name',
  'orders.builder.guestPhonePlaceholder': 'XXXX XXXX (guest mobile)',
  'orders.builder.continueToMenu': 'Continue to menu',
  'orders.builder.backToGuests': '← Guests',
  'orders.builder.placeOrder': 'Place Order',

  // Menu picker
  'orders.menuPicker.title': 'Choose a menu',
  'orders.menuPicker.showInactive': 'Show inactive / off-hours',
  'orders.menuPicker.loading': 'Loading menus…',
  'orders.menuPicker.empty': 'No menus for this location yet. Build one under Menu & Dishes.',
  'orders.menuPicker.noneActive': 'No menus are active right now.',
  'orders.menuPicker.showAll': 'Show all menus',
  'orders.menuPicker.activeNow': 'Active now',
  'orders.menuPicker.offHours': 'Off-hours',
  'orders.menuPicker.section': 'section',
  'orders.menuPicker.sections': 'sections',
  'orders.menuPicker.item': 'item',
  'orders.menuPicker.items': 'items',
  'orders.menuPicker.backToMenus': 'Menus',

  // Dish list + inline variant chooser
  'orders.cart.empty': 'No items yet — pick dishes below.',
  'orders.search.placeholder': 'Search dishes…',
  'orders.categories.all': 'All dishes',
  'orders.dishes.loading': 'Loading menu…',
  'orders.dishes.emptyMenu': 'This menu has no dishes yet. Add some under Menu & Dishes.',
  'orders.dishes.noMatch': 'No dishes match.',
  'orders.dish.deactivated': 'Deactivated',
  'orders.dish.kind.dish': 'Dish',
  'orders.dish.kind.beverage': 'Beverage',
  'orders.dish.kind.addon': 'Add-on',
  'orders.dish.kind.combo': 'Combo',
  'orders.dish.kind.other': 'Complimentary',
  'orders.dish.vegan': 'Vegan',
  'orders.dish.veg': 'Veg',
  'orders.dish.ingredients': 'Ingredients',
  'orders.dish.ingredientsTitle': 'Ingredients: {list}',
  'orders.dish.noPrice': 'No price set',
  'orders.dish.option': 'option',
  'orders.dish.options': 'options',
  'orders.variant.headerVariant': 'Variant',
  'orders.variant.headerQtyPieces': 'Qty / Pieces',
  'orders.variant.headerServes': 'Serves',
  'orders.variant.headerCalories': 'Calories',
  'orders.variant.headerPrice': 'Price',
  'orders.variant.dietTitle': '{diet} variant',
  'orders.variant.free': 'Free',
  'orders.addons.title': 'Add-ons',
  'orders.addons.note': '· optional · priced for {variant}',
  'orders.comp.loading': 'Loading complimentary items…',
  'orders.comp.title': 'Complimentary',
  'orders.comp.note': '· required · one per type',
  'orders.comp.selectPlaceholder': 'Select {kind}… (free)',
  'orders.comp.chooseFirstTitle': 'Choose a complimentary item for each type',
  'orders.comp.chooseFirst': 'Choose complimentary first',
  'orders.qty': 'Qty',
  'orders.addToOrder': 'Add {qty} to order',

  // --- Active / All orders list --------------------------------------------
  'orders.list.activeTitle': 'Active Orders',
  'orders.list.allTitle': 'All Orders',
  'orders.list.activeSubtitle': 'Orders whose payment is not settled yet',
  'orders.list.allSubtitle': 'Every order of the day — active and completed',
  'orders.list.todayHeading': 'Today\'s Orders',
  'orders.list.activeHint': 'Unpaid orders — everything still open before the bill is settled',
  'orders.list.allHint': 'All orders placed today, including completed and cancelled ones',
  'orders.list.loading': 'Loading orders...',
  'orders.list.emptyActiveTitle': 'No Active Orders',
  'orders.list.emptyAllTitle': 'No Orders Today',
  'orders.list.emptyActive': 'No unpaid orders right now',
  'orders.list.emptyAll': 'No orders have been placed today yet',
  'orders.list.table': 'Table {number}',
  'orders.list.shared': 'SHARED · {count}',
  'orders.list.guestNote': 'Guest note:',
  'orders.list.advanceAppliedTitle': 'Booking advance already adjusted in this bill',
  'orders.list.advancePendingTitle': 'Paid with the reservation — deducted when the bill is settled',
  'orders.list.advanceLine': '{total} − {advance} advance',
  'orders.list.advanceAdjusted': ' (adjusted)',
  'orders.list.startPreparing': 'Start Preparing',
  'orders.list.markReady': 'Mark Ready',
  'orders.list.markServed': 'Mark Served',
  'orders.list.markPaid': 'Mark Paid',
  'orders.list.historyTitle': 'Order history — who did what, when',
  'orders.item.prepare': 'Prepare',
  'orders.item.ready': 'Ready',
  'orders.item.serve': 'Serve',
  'orders.item.markTitle': 'Mark this item {status}',

  // Audit trail dialog
  'orders.audit.dialogTitle': 'History — {order}',
  'orders.audit.loading': 'Loading history…',
  'orders.audit.empty': 'No history recorded for this order (it predates audit logging).',
  'orders.audit.created': 'Order created',
  'orders.audit.itemsAdded': 'Items added',
  'orders.audit.total': 'total {amount}',
  'orders.audit.totalNow': 'total now {amount}',
  'orders.audit.sentBackToKitchen': 'order sent back to the kitchen',
  'orders.audit.statusChanged': 'Status changed: {from} → {to}',
  'orders.audit.itemStatusChanged': '{item}: {from} → {to}',
  'orders.audit.item': 'Item',
  'orders.audit.cancelled': 'Order cancelled',
  'orders.audit.actorGuest': ' (guest)',
  'orders.audit.actorStaff': ' (staff)',

  // Order placed dialog
  'orders.success.title': 'Order Saved!',
  'orders.success.message': 'Your order has been placed successfully',

  // --- Kitchen board --------------------------------------------------------
  'orders.kitchen.title': 'Kitchen View',
  'orders.kitchen.clockTitle': 'The time now',
  'orders.kitchen.newDish': '{count} new dish',
  'orders.kitchen.newDishes': '{count} new dishes',
  'orders.kitchen.refresh': 'Refresh',
  'orders.kitchen.toneOn': 'New-order tone is ON',
  'orders.kitchen.toneOff': 'New-order tone is OFF',
  'orders.kitchen.soundOn': 'Sound on',
  'orders.kitchen.soundOff': 'Sound off',
  'orders.kitchen.guestsWaiting': 'Buffet guests waiting',
  'orders.kitchen.table': 'Table {code}',
  'orders.kitchen.ago': '{time} ago',
  'orders.kitchen.onIt': 'On it',
  'orders.kitchen.saving': 'Saving…',
  'orders.kitchen.served': 'Served',
  'orders.kitchen.takenToTable': 'Taken to the table',
  'orders.kitchen.requestUpdateFailed': 'Could not update the request',
  'orders.kitchen.refillsTitle': 'Buffet counter needs more',
  'orders.kitchen.pcs': '{qty} pcs',
  'orders.kitchen.kg': '{qty} kg',
  'orders.kitchen.sending': 'Sending…',
  'orders.kitchen.sent': 'Sent',
  'orders.kitchen.sentToCounter': 'Sent to the counter',
  'orders.kitchen.sentFailed': 'Could not mark it sent',
  'orders.kitchen.moveToast': '{qty} × {name} — table {table}',
  'orders.kitchen.updateFailed': 'Update failed',
  'orders.kitchen.updateFailedDesc': 'Could not update the dish',
  'orders.kitchen.startCooking': 'Start Cooking',
  'orders.kitchen.garnishFinalize': 'Garnish & Finalize',
  'orders.kitchen.onHold': 'On hold — not fired yet',
  'orders.kitchen.queue': 'Dishes in Queue',
  'orders.kitchen.queueEmpty': 'Nothing waiting',
  'orders.kitchen.inProcess': 'In Process',
  'orders.kitchen.inProcessEmpty': 'Nothing on the fire',
  'orders.kitchen.readyToServe': 'Ready to Serve',
  'orders.kitchen.readyEmpty': 'Nothing ready for pickup',
  'orders.kitchen.orderTitle': 'Order #{number}',
  'orders.kitchen.detailTable': 'Table:',
  'orders.kitchen.detailStatus': 'Status:',
  'orders.kitchen.detailCustomer': 'Customer:',
  'orders.kitchen.detailWaiting': 'Waiting:',
  'orders.kitchen.orderNote': 'Order note',
  'orders.kitchen.items': 'Items',
};

export const fr = {
  // --- Toasts & confirmations shared by the order screens -------------------
  'orders.toast.error': 'Erreur',
  'orders.toast.loadTablesFailed': 'Échec du chargement des tables. Veuillez réessayer.',
  'orders.toast.loadOrdersFailed': 'Échec du chargement des commandes. Veuillez réessayer.',
  'orders.toast.saveOrderFailed': 'Échec de l\'enregistrement de la commande. Veuillez réessayer.',
  'orders.toast.statusUpdated': 'Statut mis à jour',
  'orders.toast.statusUpdatedDesc': '{order} est maintenant {status}',
  'orders.toast.updateStatusFailed': 'Échec de la mise à jour du statut de la commande',
  'orders.toast.updateItemFailed': 'Échec de la mise à jour du statut du plat',
  'orders.toast.orderCancelled': 'Commande annulée',
  'orders.toast.orderCancelledDesc': '{order} marquée annulée',
  'orders.toast.cancelFailed': 'Échec de l\'annulation de la commande',
  'orders.toast.loadHistoryFailed': 'Échec du chargement de l\'historique de la commande',
  'orders.toast.pickComplimentary': 'Choisissez un article offert',
  'orders.toast.pickComplimentaryDesc': 'Veuillez choisir un article offert pour chaque type.',
  'orders.confirm.cancelOrder': 'Annuler la commande {order} ? Son numéro reste réservé comme annulé.',
  'orders.confirm.cancelOrderCta': 'Annuler la commande',

  // Status LABELS only — the underlying values stay the server's own strings.
  // Libellés uniquement — `channel` garde les valeurs du serveur.
  'orders.channel.kiosk': 'Borne',
  'orders.channel.kioskNamed': 'Borne · {name}',
  'orders.channel.app': 'Téléphone client',
  'orders.channel.counter': 'Comptoir',
  'orders.channel.delivery': 'Livraison',
  'orders.channel.online': 'En ligne',
  'orders.channel.table': 'Table {number}',

  'orders.status.pending': 'En attente',
  'orders.status.ordered': 'Commandé',
  'orders.status.confirmed': 'Confirmé',
  'orders.status.preparing': 'En préparation',
  'orders.status.ready': 'Prêt',
  'orders.status.served': 'Servi',
  'orders.status.delivered': 'Livré',
  'orders.status.completed': 'Terminé',
  'orders.status.cancelled': 'Annulé',
  'orders.status.held': 'En attente d\'envoi',

  // --- POS shell: left rail, step chips and serving-time chips --------------
  'orders.nav.home': 'Accueil',
  'orders.nav.reservations': 'Réservations',
  'orders.nav.activeOrders': 'Commandes actives',
  'orders.nav.allOrders': 'Toutes les commandes',
  'orders.step.table': 'Table',
  'orders.step.guests': 'Couverts',
  'orders.step.menu': 'Menu',
  'orders.step.pay': 'Paiement',
  'orders.window.branchHours': 'Horaires du restaurant',
  'orders.window.from': 'À partir de {time}',
  'orders.window.until': 'Jusqu\'à {time}',

  'orders.pos.floorMaps': 'Plans de salle',
  'orders.pos.loadingFloorMaps': 'Chargement des plans de salle…',
  'orders.pos.noLocation': 'Aucun emplacement sélectionné.',
  'orders.pos.noFloorPlan': 'Aucun plan de salle. Créez-en un dans Emplacements → Plan de salle.',
  'orders.pos.noSections': 'Aucune section à cet étage.',
  'orders.pos.takeAnOrder': 'Prendre une commande',
  'orders.pos.noFloorMap': 'Aucun plan de salle',
  'orders.pos.legendAvailable': 'Libre',
  'orders.pos.legendOccupied': 'Occupée',
  'orders.pos.legendSelected': 'Sélectionnée',
  'orders.pos.tablesSeats': '{tables} tables · {seats} places',
  'orders.pos.zoomOut': 'Zoom arrière',
  'orders.pos.zoomIn': 'Zoom avant',
  'orders.pos.fitToScreen': 'Ajuster à l\'écran',
  'orders.pos.resetZoom': 'Réinitialiser le zoom à 100 %',
  'orders.pos.emptyPickLocation': 'Sélectionnez un emplacement pour charger son plan de salle',
  'orders.pos.emptyNoFloorPlan': 'Aucun plan de salle — créez-en un dans Emplacements → Plan de salle',
  'orders.pos.emptyNoTables': 'Aucune table dans cette section',
  'orders.pos.selectedLabel': 'Sélection',
  'orders.pos.tapTable': 'Touchez une table libre sur le plan de salle',
  'orders.pos.seats': '{count} places',
  'orders.pos.reset': 'Réinitialiser',
  'orders.pos.next': 'Suivant',

  // --- Order builder: party size, then menu, then place ---------------------
  'orders.builder.backToTables': '← Tables',
  'orders.builder.tableSummary': '{table} · {seats} places',
  'orders.builder.newOrder': 'Nouvelle commande',
  'orders.builder.guests': '{count} couvert(s)',
  'orders.builder.total': 'Total',
  'orders.builder.howManyGuests': 'Combien de couverts ?',
  'orders.builder.upToSeats': 'Jusqu\'à {count} places à cette table',
  'orders.builder.guestDetails': 'Coordonnées du client',
  'orders.builder.guestNamePlaceholder': 'Nom du client',
  'orders.builder.guestPhonePlaceholder': 'XXXX XXXX (portable du client)',
  'orders.builder.continueToMenu': 'Continuer vers le menu',
  'orders.builder.backToGuests': '← Couverts',
  'orders.builder.placeOrder': 'Valider la commande',

  // Menu picker
  'orders.menuPicker.title': 'Choisissez un menu',
  'orders.menuPicker.showInactive': 'Afficher les inactifs / hors horaires',
  'orders.menuPicker.loading': 'Chargement des menus…',
  'orders.menuPicker.empty': 'Aucun menu pour cet emplacement. Créez-en un dans Menu & Plats.',
  'orders.menuPicker.noneActive': 'Aucun menu n\'est actif en ce moment.',
  'orders.menuPicker.showAll': 'Afficher tous les menus',
  'orders.menuPicker.activeNow': 'Actif maintenant',
  'orders.menuPicker.offHours': 'Hors horaires',
  'orders.menuPicker.section': 'section',
  'orders.menuPicker.sections': 'sections',
  'orders.menuPicker.item': 'article',
  'orders.menuPicker.items': 'articles',
  'orders.menuPicker.backToMenus': 'Menus',

  // Dish list + inline variant chooser
  'orders.cart.empty': 'Aucun article — choisissez des plats ci-dessous.',
  'orders.search.placeholder': 'Rechercher un plat…',
  'orders.categories.all': 'Tous les plats',
  'orders.dishes.loading': 'Chargement du menu…',
  'orders.dishes.emptyMenu': 'Ce menu n\'a encore aucun plat. Ajoutez-en dans Menu & Plats.',
  'orders.dishes.noMatch': 'Aucun plat correspondant.',
  'orders.dish.deactivated': 'Désactivé',
  'orders.dish.kind.dish': 'Plat',
  'orders.dish.kind.beverage': 'Boisson',
  'orders.dish.kind.addon': 'Supplément',
  'orders.dish.kind.combo': 'Formule',
  'orders.dish.kind.other': 'Offert',
  'orders.dish.vegan': 'Végane',
  'orders.dish.veg': 'Végé',
  'orders.dish.ingredients': 'Ingrédients',
  'orders.dish.ingredientsTitle': 'Ingrédients : {list}',
  'orders.dish.noPrice': 'Aucun prix défini',
  'orders.dish.option': 'option',
  'orders.dish.options': 'options',
  'orders.variant.headerVariant': 'Variante',
  'orders.variant.headerQtyPieces': 'Qté / Pièces',
  'orders.variant.headerServes': 'Pers.',
  'orders.variant.headerCalories': 'Calories',
  'orders.variant.headerPrice': 'Prix',
  'orders.variant.dietTitle': 'Variante {diet}',
  'orders.variant.free': 'Offert',
  'orders.addons.title': 'Suppléments',
  'orders.addons.note': '· facultatif · tarif pour {variant}',
  'orders.comp.loading': 'Chargement des articles offerts…',
  'orders.comp.title': 'Offerts',
  'orders.comp.note': '· obligatoire · un par type',
  'orders.comp.selectPlaceholder': 'Choisir {kind}… (offert)',
  'orders.comp.chooseFirstTitle': 'Choisissez un article offert pour chaque type',
  'orders.comp.chooseFirst': 'Choisissez d\'abord les articles offerts',
  'orders.qty': 'Qté',
  'orders.addToOrder': 'Ajouter {qty} à la commande',

  // --- Active / All orders list --------------------------------------------
  'orders.list.activeTitle': 'Commandes actives',
  'orders.list.allTitle': 'Toutes les commandes',
  'orders.list.activeSubtitle': 'Commandes dont le paiement n\'est pas encore réglé',
  'orders.list.allSubtitle': 'Toutes les commandes du jour — actives et terminées',
  'orders.list.todayHeading': 'Commandes du jour',
  'orders.list.activeHint': 'Commandes impayées — tout ce qui reste ouvert avant le règlement de l\'addition',
  'orders.list.allHint': 'Toutes les commandes passées aujourd\'hui, y compris terminées et annulées',
  'orders.list.loading': 'Chargement des commandes...',
  'orders.list.emptyActiveTitle': 'Aucune commande active',
  'orders.list.emptyAllTitle': 'Aucune commande aujourd\'hui',
  'orders.list.emptyActive': 'Aucune commande impayée en ce moment',
  'orders.list.emptyAll': 'Aucune commande n\'a encore été passée aujourd\'hui',
  'orders.list.table': 'Table {number}',
  'orders.list.shared': 'PARTAGÉE · {count}',
  'orders.list.guestNote': 'Note du client :',
  'orders.list.advanceAppliedTitle': 'Acompte de réservation déjà déduit de cette addition',
  'orders.list.advancePendingTitle': 'Payé lors de la réservation — déduit au règlement de l\'addition',
  'orders.list.advanceLine': '{total} − {advance} d\'acompte',
  'orders.list.advanceAdjusted': ' (déduit)',
  'orders.list.startPreparing': 'Lancer la préparation',
  'orders.list.markReady': 'Marquer prêt',
  'orders.list.markServed': 'Marquer servi',
  'orders.list.markPaid': 'Marquer payé',
  'orders.list.historyTitle': 'Historique de la commande — qui a fait quoi, quand',
  'orders.item.prepare': 'Préparer',
  'orders.item.ready': 'Prêt',
  'orders.item.serve': 'Servir',
  'orders.item.markTitle': 'Marquer ce plat comme {status}',

  // Audit trail dialog
  'orders.audit.dialogTitle': 'Historique — {order}',
  'orders.audit.loading': 'Chargement de l\'historique…',
  'orders.audit.empty': 'Aucun historique pour cette commande (elle est antérieure au journal d\'audit).',
  'orders.audit.created': 'Commande créée',
  'orders.audit.itemsAdded': 'Articles ajoutés',
  'orders.audit.total': 'total {amount}',
  'orders.audit.totalNow': 'nouveau total {amount}',
  'orders.audit.sentBackToKitchen': 'commande renvoyée en cuisine',
  'orders.audit.statusChanged': 'Statut modifié : {from} → {to}',
  'orders.audit.itemStatusChanged': '{item} : {from} → {to}',
  'orders.audit.item': 'Article',
  'orders.audit.cancelled': 'Commande annulée',
  'orders.audit.actorGuest': ' (client)',
  'orders.audit.actorStaff': ' (personnel)',

  // Order placed dialog
  'orders.success.title': 'Commande enregistrée !',
  'orders.success.message': 'Votre commande a bien été enregistrée',

  // --- Kitchen board --------------------------------------------------------
  'orders.kitchen.title': 'Vue cuisine',
  'orders.kitchen.clockTitle': 'Heure actuelle',
  'orders.kitchen.newDish': '{count} nouveau plat',
  'orders.kitchen.newDishes': '{count} nouveaux plats',
  'orders.kitchen.refresh': 'Actualiser',
  'orders.kitchen.toneOn': 'Signal sonore des nouvelles commandes ACTIVÉ',
  'orders.kitchen.toneOff': 'Signal sonore des nouvelles commandes DÉSACTIVÉ',
  'orders.kitchen.soundOn': 'Son activé',
  'orders.kitchen.soundOff': 'Son coupé',
  'orders.kitchen.guestsWaiting': 'Clients du buffet en attente',
  'orders.kitchen.table': 'Table {code}',
  'orders.kitchen.ago': 'il y a {time}',
  'orders.kitchen.onIt': 'En cours',
  'orders.kitchen.saving': 'Enregistrement…',
  'orders.kitchen.served': 'Servi',
  'orders.kitchen.takenToTable': 'Apporté à la table',
  'orders.kitchen.requestUpdateFailed': 'Impossible de mettre à jour la demande',
  'orders.kitchen.refillsTitle': 'Le buffet a besoin de réassort',
  'orders.kitchen.pcs': '{qty} pcs',
  'orders.kitchen.kg': '{qty} kg',
  'orders.kitchen.sending': 'Envoi…',
  'orders.kitchen.sent': 'Envoyé',
  'orders.kitchen.sentToCounter': 'Envoyé au buffet',
  'orders.kitchen.sentFailed': 'Impossible de marquer comme envoyé',
  'orders.kitchen.moveToast': '{qty} × {name} — table {table}',
  'orders.kitchen.updateFailed': 'Échec de la mise à jour',
  'orders.kitchen.updateFailedDesc': 'Impossible de mettre à jour le plat',
  'orders.kitchen.startCooking': 'Lancer la cuisson',
  'orders.kitchen.garnishFinalize': 'Dresser & finaliser',
  'orders.kitchen.onHold': 'En attente — pas encore lancé',
  'orders.kitchen.queue': 'Plats en attente',
  'orders.kitchen.queueEmpty': 'Rien en attente',
  'orders.kitchen.inProcess': 'En préparation',
  'orders.kitchen.inProcessEmpty': 'Rien sur le feu',
  'orders.kitchen.readyToServe': 'Prêt à servir',
  'orders.kitchen.readyEmpty': 'Rien à passer',
  'orders.kitchen.orderTitle': 'Commande n° {number}',
  'orders.kitchen.detailTable': 'Table :',
  'orders.kitchen.detailStatus': 'Statut :',
  'orders.kitchen.detailCustomer': 'Client :',
  'orders.kitchen.detailWaiting': 'Attente :',
  'orders.kitchen.orderNote': 'Note de commande',
  'orders.kitchen.items': 'Articles',
};
